import type {ReactElement} from 'react';
import React from 'react';
import {Dropdown} from '@Components/dropdown-v2';
import {ALIGNMENT_TYPE, DROPDOWN_POSITION} from '@Components/dropdown-v2/dropdown.types';
import styles from './base-size-dropdown.module.scss';

interface BaseSizeDropdownProps {
  popup: ReactElement;
  selector: ReactElement;
  modalTitle: string;
  doesCloseOnOuterClick?: boolean;
  popupSpacingClass?: string;
  showSmallWidthPopup?: boolean;
  modalContent?: ReactElement;
}

export function BaseSizeDropdown({showSmallWidthPopup = false, doesCloseOnOuterClick = true, popupSpacingClass = 'spacing-p-3', ...props}: BaseSizeDropdownProps): ReactElement {
  return (
    <Dropdown
      alignment={ALIGNMENT_TYPE.BOTTOM_END}
      maxHeight={380}
      showModalForSmallScreen
      position={DROPDOWN_POSITION.FIXED}
      modalTitle={props.modalTitle}
      popup={props.popup}
      modalContent={props.modalContent}
      selector={props.selector}
      popupClassName={`${styles.popup} ${showSmallWidthPopup ? styles.small : ''}`}
      popUpHasCustomWidth
      popupSpacingClass={popupSpacingClass}
      doesCloseOnOuterClick={doesCloseOnOuterClick}
    />
  );
}
